import {
    createOptionPicker,
    OptionPicker,
} from '@vfde-brix/ws10/option-picker';
import { setHardwareOnly } from 'Container/App/slice';
import { IInitialState } from 'Container/App/interface';
import { useDispatch } from '../store';

const mountHardwareOnlyPicker = (
    containerId: string,
    { isHardwareOnly }: IInitialState['customerConfig'],
): OptionPicker | null => {
    const dispatch = useDispatch();
    const container = document.getElementById(containerId);

    /* istanbul ignore next */
    if (!container) {
        return null;
    }

    const picker = createOptionPicker(container, {
        onChange: (event: Event) => {
            dispatch(setHardwareOnly((event.target as HTMLInputElement).value === 'true'));
        },
    });

    picker.update({
        items: [
            ...picker.getProperties().items.map(item => ({
                ...item,
                optChecked: item.stdValue === `${isHardwareOnly}`,
            })),
        ],
    });

    return picker;
};

export default mountHardwareOnlyPicker;
